var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.20828C0 0.54088 0.554587 0 1.23886 0H15.6307C16.315 0 16.8696 0.54088 16.8696 1.20828V15.6613C16.8696 16.3287 16.315 16.8696 15.6307 16.8696H1.23886C0.554587 16.8696 0 16.3287 0 15.6613V1.20828ZM5.21164 14.1219V6.50427H2.68015V14.1219H5.21164ZM3.94642 5.46363C4.82891 5.46363 5.37823 4.87952 5.37823 4.1478C5.36241 3.40027 4.82997 2.83198 3.96329 2.83198C3.09662 2.83198 2.53044 3.40133 2.53044 4.1478C2.53044 4.87952 3.07975 5.46363 3.92955 5.46363H3.94642ZM9.12116 14.1219V9.86764C9.12116 9.6399 9.13803 9.41216 9.20551 9.24979C9.38791 8.79537 9.80438 8.32408 10.5045 8.32408C11.4207 8.32408 11.7866 9.02205 11.7866 10.0469V14.1219H14.318V9.75272C14.318 7.41207 13.0697 6.32398 11.4038 6.32398C10.0606 6.32398 9.45856 7.06202 9.12116 7.58182V7.60817H9.10429C9.10989 7.59937 9.11552 7.59059 9.12116 7.58182V6.50427H6.59073C6.62236 7.21912 6.59073 14.1219 6.59073 14.1219H9.12116Z",
    fill: "#0181AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinSmallIcon);
export default __webpack_public_path__ + "static/media/LinkedinSmallIcon.07a64f2696dd5f97a08186b53558ab11.svg";
export { ForwardRef as ReactComponent };